import { AUTH_TOKEN } from "constants/AuthConstant";
import fetch from "auth/FetchInterceptor";

const PartnerService = {};

PartnerService.getAllPartners = function (searchValue = {}, page = 1) {
  let url = `/partner/getAll?page=${page}&limit=10`;

  if (searchValue.fullName) {
    url += `&fullName=${encodeURIComponent(searchValue.fullName)}`;
  }
  if (searchValue.email) {
    url += `&email=${encodeURIComponent(searchValue.email)}`;
  }
  if (searchValue.phoneNumber) {
    url += `&phoneNumber=${encodeURIComponent(searchValue.phoneNumber)}`;
  }

  return fetch({
    method: "get",
    url: url,
    headers: {
      Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
    },
  });
};

PartnerService.getPartnerById = function (id) {
  return fetch({
    method: "get",
    url: `/partner/getById/${id}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
    },
  });
};
PartnerService.updatePartnerStatus = function (id, status) {
  return fetch({
    method: "put",
    url: `/admin/updateStatus/${id}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
    },
    data: { status },
  });
};

PartnerService.createPartner = function (data) {
  console.log(data);
  return fetch({
    method: "post",
    url: `/partner/create`,
    data: data,
    headers: {
      Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
    },
  });
};

PartnerService.updatePartnerById = function (id, data) {
  return fetch({
    method: "put",
    url: `/partner/update/${id}`,
    data: data,
    headers: {
      Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
      "Content-Type": "multipart/form-data",
    },
  });
};

PartnerService.deletePartnerById = function (id) {
  return fetch({
    method: "delete",
    url: `/partner/${id}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
    },
  });
};

export default PartnerService;
